export default {
  STAGE: process.env.NODE_ENV || 'development',
  SENTRY_RELEASE: process.env.REACT_APP_RELEASE || '',
  GOOGLE_ANALYTICS: 'UA-134099424-2',
  GOOGLE_API_KEY: 'AIzaSyChUKUfbWY2kXuh6VBoYdlJoMEpjDM03_I',
  // NOTE: First one in the list will be the system defalt.
  AVAILABLE_LANGUAGES: ['en', 'ja'],
  DEFAULT_ERROR: 'Sorry something went wrong',
};
